import { render, staticRenderFns } from "./AddDeviceCategory.vue?vue&type=template&id=4d686743"
import script from "./AddDeviceCategory.vue?vue&type=script&lang=ts"
export * from "./AddDeviceCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports